import { useMutation } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import SAVE_VISITA_BOMBA_AP, { addVisitaBombaInfusionInput } from "../../../../../../data/graphQL/mutations/Visitas/saveBomba";

import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function BombaDeInfusion({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  //QUERY y MUTATION
  const [save] = useMutation(SAVE_VISITA_BOMBA_AP);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { ...addVisitaBombaInfusionInput(formData) } });

    const idBombaInfusionTelemedicina = data?.saveVisitaBombaInfusionAP?.idBombaInfusionTelemedicina;
    if (!idBombaInfusionTelemedicina) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idBombaInfusionTelemedicina: idBombaInfusionTelemedicina
    }));

  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'bombaInfusion',
      stepName: 'Bomba Infusion',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
            <RenderInputByTypeMobile
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const inputs = [
{
  name: "estaEnchufada",
  displayName: "¿Está enchufada la bomba?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "funcionamientoAdecuado",
  displayName: "¿Su funcionamiento es adecuado?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "remanenteBolsa",
  displayName: "¿Pasa toda la bolsa o queda remanente?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "mantenimientoBomba",
  displayName: "¿Cómo mantiene en condiciones su bomba?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "alarmasSuenan",
  displayName: "¿Suenan mucho las alarmas?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "modeloBomba",
  displayName: "¿Qué bomba tiene?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "reemplazoBomba",
  displayName:
  "¿Tuvo que reemplazar su bomba por mal funcionamiento en este tiempo?",
  type: "long_string",
  maxLength: 250,
  required: true
}];